import { connect } from 'react-redux';

import { openModal } from 'src/store/modals/actions';
import { ModalTypes } from 'src/store/modals/instances';
import { JobNavLayout } from 'src/layouts/job-details-layout';

import { InstanceType } from '../../../store/Instances/Instances';
import { createObject, updateObject, deleteObject } from '../../../store/Instance/Actions';

const mapStateToProps = (state: any) => ({
  isDeleteLoading: state.instance[InstanceType.DELETE_JOB]?.loading || false,
  isDuplicateLoading: state.instance[InstanceType.DUPLICATE_JOB]?.loading || false,
});

const mapDispatchToProps = (dispatch: any) => ({
  updateJobDetails: (
    jobId: string,
    payload: any,
    callback: (data: any, success: boolean) => void
  ) =>
    dispatch(
      updateObject({
        instanceType: InstanceType.JOB_DETAILS_UPDATE,
        dynamicUrlData: `/${jobId}/Update`,
        callback,
        data: payload,
      })
    ),
  openJobShareModal: (jobCardProps: any) =>
    dispatch(openModal({ modalType: ModalTypes.jobShareModal, params: { jobCardProps } })),
  duplicateJob: (jobId: string, callback: (data: any, success: boolean) => void) =>
    dispatch(
      createObject({
        instanceType: InstanceType.DUPLICATE_JOB,
        dynamicUrlData: `/${jobId}/Duplicate`,
        callback,
      })
    ),
  deleteJob: (jobId: string, callback: (data: any, success: boolean) => void) =>
    dispatch(
      deleteObject({
        instanceType: InstanceType.DELETE_JOB,
        dynamicUrlData: `/${jobId}`,
        callback,
      })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(JobNavLayout);
